var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "form-designer-container" },
    [
      _c(
        "el-header",
        { staticClass: "toolbar-header" },
        [_vm._t("default")],
        2
      ),
      _vm._v(" "),
      _c(
        "el-container",
        { staticClass: "main full-height" },
        [
          _c(
            "el-container",
            [
              _c(
                "el-aside",
                {
                  staticClass: "side-panel",
                  class: !_vm.leftAsideVisible
                    ? "aside-hidden"
                    : "aside-visible",
                },
                [_c("FieldPanel", { attrs: { designer: _vm.designer } })],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "left-aside-toggle-bar",
                  class: { "aside-hidden": !_vm.leftAsideVisible },
                  on: { click: _vm.toggleLeftAside },
                },
                [
                  _c("i", {
                    staticClass: "el-icon",
                    class: !_vm.leftAsideVisible
                      ? "el-icon-arrow-right"
                      : "el-icon-arrow-left",
                  }),
                ]
              ),
              _vm._v(" "),
              _c(
                "el-container",
                { staticClass: "center-layout-container" },
                [
                  _c(
                    "el-main",
                    { staticClass: "form-widget-main" },
                    [
                      _c(
                        "el-scrollbar",
                        { staticClass: "container-scroll-bar" },
                        [
                          _c("VFormWidget", {
                            ref: "formRef",
                            attrs: {
                              designer: _vm.designer,
                              "form-config": _vm.designer.formConfig,
                              "global-dsv": _vm.globalDsv,
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-aside",
                { staticClass: "setting-panel" },
                [
                  _c("SettingPanel", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.rightAsideVisible,
                        expression: "rightAsideVisible",
                      },
                    ],
                    attrs: {
                      designer: _vm.designer,
                      "selected-widget": _vm.designer.selectedWidget,
                      "form-config": _vm.designer.formConfig,
                      "global-dsv": _vm.globalDsv,
                    },
                  }),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "right-aside-toggle-bar",
                      class: { "aside-hidden": !_vm.rightAsideVisible },
                      on: { click: _vm.toggleRightAside },
                    },
                    [
                      _c("i", {
                        staticClass: "el-icon",
                        class: !_vm.rightAsideVisible
                          ? "el-icon-arrow-left"
                          : "el-icon-arrow-right",
                      }),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _vm.showPreviewDialogFlag
        ? _c(
            "el-dialog",
            {
              directives: [{ name: "dialog-drag", rawName: "v-dialog-drag" }],
              staticClass: "small-padding-dialog",
              attrs: {
                title: "预览",
                visible: _vm.showPreviewDialogFlag,
                "show-close": true,
                "close-on-click-modal": false,
                "close-on-press-escape": false,
                center: "",
                "destroy-on-close": true,
                "append-to-body": true,
                width: "75%",
                fullscreen: false,
              },
              on: {
                "update:visible": function ($event) {
                  _vm.showPreviewDialogFlag = $event
                },
              },
            },
            [
              _c(
                "div",
                { staticClass: "form-render-wrapper" },
                [
                  _c("VFormRender", {
                    ref: "preForm",
                    attrs: {
                      "form-json": _vm.designer,
                      "preview-state": true,
                      "option-data": _vm.testOptionData,
                      "global-dsv": _vm.globalDsv,
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "dialog-footer",
                  attrs: { slot: "footer" },
                  slot: "footer",
                },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "" },
                      on: {
                        click: function ($event) {
                          _vm.showPreviewDialogFlag = false
                        },
                      },
                    },
                    [_vm._v("关闭")]
                  ),
                ],
                1
              ),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _c("oa-dialog", {
        ref: "oaDialog",
        attrs: {
          fromData: _vm.fromData,
          formConfig: _vm.formConfig,
          formRules: _vm.formRules,
          formDataInit: _vm.formDataInit,
        },
        on: { submit: _vm.submit },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }